import { render, staticRenderFns } from "./NewDevolution.vue?vue&type=template&id=923975a4&lang=html&"
import script from "./NewDevolution.vue?vue&type=script&lang=js&"
export * from "./NewDevolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports